module.exports = __webpack_public_path__ + "assets/6f7867b333029a1ad75193f75d0edaca.png";